import './App.css';
import Login from './pages/Login';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Overview from './pages/Overview';
import { createTheme, ThemeProvider } from '@mui/material';
import Clients from './pages/Clients';
import Referrals from './pages/Referrals';
import Profile from './pages/Profile';
import Users from './pages/Users';
import { ToastContainer } from 'react-toastify';
import { useState } from 'react';
import { AuthContext } from './utils/AuthContext';
import { Helmet } from "react-helmet";
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoutes from './utils/PrivateRoutes';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import NotFoundPage from './pages/NotFoundPage';
import NotFound from './pages/NotFound';


// Create a theme with custom colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#3328BF', // Custom primary color (blue)
    },
  },
});


function App() {

  const token = localStorage.getItem('agent-connect-api-token');

  let user;
  if (JSON.parse(localStorage.getItem('agent-connect-current-user'))) {
    user = JSON.parse(localStorage.getItem('agent-connect-current-user'));
  }

  const [auth, setAuth] = useState({
    token,
    user
  });

  const privateRoutes = [
    { path: '/overview', element: <Overview />, userType: 'Admin' },
    { path: '/clients', element: <Clients /> },
    { path: '/referrals', element: <Referrals /> },
    { path: '/users', element: <Users />, userType: 'User' },
    { path: '/profile', element: <Profile /> },
  ];

  // Filter routes based on user type
  const filteredPrivateRoutes = privateRoutes.filter(route => {
    if (auth?.user?.user_type === 'Agent' && route.path === '/users') {
      return false;
    }
    if (auth?.user?.user_type === 'Admin' && route.path === '/overview') {
      return false;
    }
    return true; // Keep all other routes
  });


  return (
    <>

      <Helmet>
        <title>AgentConnect+</title>
      </Helmet>

      <ToastContainer />

      <AuthContext.Provider value={{ auth, setAuth }}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route element={<ForgotPassword />} path='/forgot_password' />
              <Route element={<ResetPassword />} path='/reset_password' />
              <Route element={<Login />} path='/login' />
              <Route element={<Login />} path='/' />

              <Route component={NotFound} />

              <Route element={<PrivateRoutes />}>
                {filteredPrivateRoutes.map(route => (
                  <Route key={route.path} path={route.path} element={route.element} />
                ))}
              </Route>

              <Route path="*" element={<NotFoundPage />} /> {/* 404 fallback route */}
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </AuthContext.Provider>
    </>
  );
}

export default App;
